import React from 'react'
import { Header, Footer } from '.'

const Layout = ({ children }) => {
  return (
    <>
      <Header />
      {children}
      <Footer />
    </>
  )
}

export { Layout }
